import {EventDefinitionsStore} from 'common/report/stores/event-definitions';
import {contextify} from 'common/util/react';

const context = contextify<EventDefinitionsStore>();

/** @deprecated use the EventDefinitions ModelResource */
export const EventDefinitionsProvider = context.Provider;
/** @deprecated use the EventDefinitions ModelResource */
export const EventDefinitionsConsumer = context.Consumer;
/** @deprecated use the EventDefinitions ModelResource */
export const useEventDefinitions = context.hook;
